module.exports = __webpack_public_path__ + "img/map_Z5.5.A.01.8ff1220f.svg";